import { useState, useRef, useEffect } from "react";
import get from "lodash/get";

function OutsideClick(initialIsVisible) {
    const [isVisible, setIsVisible] = useState(initialIsVisible);
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
			let a = false;
			['react-datepicker','react-datepicker__header'].forEach(key => {
				if(event.target && event.target.offsetParent && get(event, 'target.offsetParent.classList').contains(key)){
					a = true
				}
			})
			if(!a){
				setIsVisible(false);
			}
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return { ref, isVisible, setIsVisible };
}

export default OutsideClick;
